import axios from 'axios';
import {
  ICrudDeleteAction,
  ICrudGetAction,
  ICrudGetAllAction,
  ICrudPutAction,
  loadMoreDataWhenScrolled,
  parseHeaderForLinks,
} from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';

import { defaultValue, IFollowup } from 'app/shared/model/followup.model';

export const ACTION_TYPES = {
  FETCH_FOLLOWUP_LIST: 'followup/FETCH_FOLLOWUP_LIST',
  FETCH_FOLLOWUP: 'followup/FETCH_FOLLOWUP',
  CREATE_FOLLOWUP: 'followup/CREATE_FOLLOWUP',
  UPDATE_FOLLOWUP: 'followup/UPDATE_FOLLOWUP',
  DELETE_FOLLOWUP: 'followup/DELETE_FOLLOWUP',
  RESET: 'followup/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IFollowup>,
  entity: defaultValue,
  links: { next: 0 },
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type FollowupState = Readonly<typeof initialState>;

// Reducer

export default (state: FollowupState = initialState, action): FollowupState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_FOLLOWUP_LIST):
    case REQUEST(ACTION_TYPES.FETCH_FOLLOWUP):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_FOLLOWUP):
    case REQUEST(ACTION_TYPES.UPDATE_FOLLOWUP):
    case REQUEST(ACTION_TYPES.DELETE_FOLLOWUP):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_FOLLOWUP_LIST):
    case FAILURE(ACTION_TYPES.FETCH_FOLLOWUP):
    case FAILURE(ACTION_TYPES.CREATE_FOLLOWUP):
    case FAILURE(ACTION_TYPES.UPDATE_FOLLOWUP):
    case FAILURE(ACTION_TYPES.DELETE_FOLLOWUP):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_FOLLOWUP_LIST): {
      const links = parseHeaderForLinks(action.payload.headers.link);

      return {
        ...state,
        loading: false,
        links,
        entities: loadMoreDataWhenScrolled(state.entities, action.payload.data, links),
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    }
    case SUCCESS(ACTION_TYPES.FETCH_FOLLOWUP):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_FOLLOWUP):
    case SUCCESS(ACTION_TYPES.UPDATE_FOLLOWUP):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_FOLLOWUP):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/followups';

// Actions

export const getEntities: ICrudGetAllAction<IFollowup> = (page, size, sort) => {
  let requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;

  // JHipster shared code sorts by surrogate key by default and it's not displayed on the Indcient
  // list, so we know this is the initial page load if we see it as a sort param.
  // JHipster doesn't support multiple levels of sorting out of the box with React.  Spring does tho...
  if (page === 0 && sort === 'id,asc') {
    requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=status,desc` : ''}`;
  }

  return {
    type: ACTION_TYPES.FETCH_FOLLOWUP_LIST,
    payload: axios.get<IFollowup>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IFollowup> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_FOLLOWUP,
    payload: axios.get<IFollowup>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IFollowup> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_FOLLOWUP,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const updateEntity: ICrudPutAction<IFollowup> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_FOLLOWUP,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IFollowup> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_FOLLOWUP,
    payload: axios.delete(requestUrl),
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
